<template>
  <div class="recordSetting">
    <main-record-setting
      v-if="hasChild === undefined"
      :selected-records="selectedRecords"
      :selected-cams="selectedItems"
    />
    <record-download
      v-else
      :selected-items="selectedItems"
      :items="items"
      @onSelect="handleDownloadSelect"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MainRecordSetting from './MainRecordSetting.vue';
import RecordDownload from './RecordDownload.vue';
export default {
  name: 'RecordSetting',
  components: { RecordDownload, MainRecordSetting },
  data() {
    return {
      selectedItems: {},
    };
  },
  computed: {
    ...mapState({
      items: (state) => state.common.cameraList,
    }),
    hasChild() {
      return this.$route.params.child;
    },
    selectedRecords() {
      return Object.keys(this.selectedItems).map((key) => this.items[key]);
    },
  },
  methods: {
    handleDownloadSelect(i) {
      this.$set(this.selectedItems, i, !this.selectedItems[i]);
    },
  },
};
</script>

<style lang="scss">
.recordSetting {
  height: 100%;
  overflow: auto;
}
</style>
